module.exports = __webpack_public_path__ + "media/images/logo-rund-c04a97bcce27ab1ba6beb0a31d355753.png";